<template>
  <div v-if="!loading">
    <RoleInfo v-model="role" />
    <RoleInfoCondition v-model="role" />
    <RoleWallet v-for="wl in wallet" :key="wl.id" :wl="wl" />
  </div>
  <div v-else>
    <CSpinner color="primary" />
  </div>
</template>

<script>
import RoleWallet from "./RoleWallet";
import RoleInfo from "./RoleInfo";
import RoleInfoCondition from "./RoleInfoCondition";
import { apiGet } from "../../../helpers/apiHelper";

export default {
  name: "ProfileData",
  data() {
    return {
      wallet: null,
      role: null,
      loading: true,
    };
  },

  methods: {
    async fetchData() {
      this.loading = true; // Start loading

      try {
        const [roleResponse, walletResponse] = await Promise.all([
          this.getRoleInfo(),
          this.getWallet(),
        ]);

        if (roleResponse && roleResponse.data) {
          this.role = roleResponse.data;
        }

        if (walletResponse && walletResponse.data) {
          this.wallet = walletResponse.data.Items;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.loading = false;
      }
    },

    async getRoleInfo() {
      return apiGet("auth_frole", [], this.$store.state.role.id);
    },

    async getWallet() {
      return apiGet("auth_fwallet", [this.$store.state.role.family_id]);
    },
  },

  mounted() {
    this.fetchData();
  },

  components: {
    RoleWallet,
    RoleInfo,
    RoleInfoCondition,
  },
};
</script>
